import { render, staticRenderFns } from "./avaliarOrdem.vue?vue&type=template&id=dd1fc896"
import script from "./avaliarOrdem.vue?vue&type=script&lang=js"
export * from "./avaliarOrdem.vue?vue&type=script&lang=js"
import style0 from "./avaliarOrdem.vue?vue&type=style&index=0&id=dd1fc896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports